import { activeMemberships } from "lib/apollo/constants"
import type {
  MembershipPricingOption,
  PriceWithMembershipOptions,
  PricingOption,
} from "types"

const queryMembershipMap = {
  "60ft": "sixtyDayFreeTrialRenewsToMonthlyMembershipId",
  "30ft": "thirtyDayFreeTrialRenewsToMonthlyMembershipId",
  annual: "annualLimitlessMembershipId",
  monthly: "monthlyLimitlessMembershipId",
} as const

export const getMembershipIdFromQuery = (
  locale: string,
  queryMembership: string
): string => {
  if (!queryMembership) return ""
  const membershipKey = queryMembershipMap[queryMembership]
  return activeMemberships[locale][membershipKey]
}

export const isMembershipPricingOption = (
  option?: PricingOption
): option is PriceWithMembershipOptions | MembershipPricingOption => {
  return (
    option !== undefined && ("membership" in option || "memberships" in option)
  )
}
